<template>
    <SectionViewLayout
      title='settings.messages.title'
      :content_state='content_state'
      content_class="messages-options"
      close_route="settings"
      >
        <template #actions>
            <ActionButton
                @click='save()'
                icon="fas fa-save"
                :loading=content_state.saving
                v-tooltip='"global.actions.save_changes"'
                :gtm="{
                    module : 'messages_options_settings',
                    feature: 'messages_options_form',
                    block  : `top_actions`,
                    action : 'submit'
                }"
            />
        </template>

        <template #content>
            <form>
                <fieldset>
                    <legend>{{Language.say('settings.messages.labels.images')}}</legend>
                    <InputCheckbox
                      input_id="check1"
                      label_text="settings.messages.images_option_text"
                      input_name="image_replacement"
                      :true_value="1"
                      :false_value="0"
                      v-model:input_value="messages_options_controller.options.image_replacement">
                    </InputCheckbox>
                </fieldset>
                <fieldset>
                    <legend>{{Language.say('settings.messages.labels.sent_messages')}}</legend>
                    <InputCheckbox
                      input_id="check3"
                      label_text="settings.messages.sent_messages_option_text"
                      input_name="request_mdn"
                      :true_value="1"
                      :false_value="0"
                      v-model:input_value="messages_options_controller.options.request_mdn">
                    </InputCheckbox>
                </fieldset>

                <div class="submit-desktop">
                    <ActionButton
                        @click='save()'
                        class="main-action"
                        icon="fas fa-save"
                        text="global.actions.save_changes"
                        :loading=content_state.saving
                        :gtm="{
                            module : 'messages_options_settings',
                            feature: 'messages_options_form',
                            block  : `bottom_actions`,
                            action : 'submit'
                        }"
                        />
                </div>
            </form>
        </template>
    </SectionViewLayout>
</template>

<script setup>
  import { reactive, onBeforeMount } from 'vue';
  import { useRouter }                    from 'vue-router';
  import ActionButton                     from '@/vue/Elements/Buttons/ActionButton.vue';
  import SectionViewLayout                from '@/vue/Layouts/Sections/SectionViewLayout.vue';
  import MessagesOptionsController        from '@/js/Settings/MessagesOptions/MessagesOptionsController.js';
  import Language                         from '@/js/Shared/Language/Language.js';
  import ContentState                     from '@/js/Shared/State/ContentState';
  import InputCheckbox                    from '@/vue/Elements/Inputs/InputCheckbox.vue';

  const route                       = useRouter();
  const messages_options_controller = reactive(MessagesOptionsController);
  const content_state               = reactive(new ContentState());

  content_state.onErrorRetry(async () => {
    await fetchOptions();
  })

  onBeforeMount(async () => {
    await fetchOptions();
  })

  const fetchOptions = async () => {
    content_state.setLoading();
    content_state.setLoadedState(
      await messages_options_controller.fetchOptions()
    );
  }

  const save = async () => {
    content_state.setSaving(true);
    let success = await messages_options_controller.saveOptions()
    content_state.setSaving(false);

    if (success) {
      close()
      return;
    }
  }

  const close = () => {
    route.push('/settings/');
  }

</script>